import {unexpectedCase} from 'nutshell-core/reducer-utils';

// @ts-expect-error
import {ActionTypes, ToggleSidebarDismissAction} from './onboarding-actions';

export type OnboardingState = {
    isOnboardingSidebarDismissed: boolean;
};

export const defaultOnboardingState = {
    isOnboardingSidebarDismissed: false,
} as const;

export const onboardingReducer = (
    state: OnboardingState | null | undefined = defaultOnboardingState,
    action: ToggleSidebarDismissAction
): OnboardingState => {
    switch (action.type) {
        case ActionTypes.TOGGLE_SIDEBAR_DISMISSED:
            return {
                isOnboardingSidebarDismissed: action.payload.isOnboardingSidebarDismissed,
            };
        default:
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
